import config from './config';
import showToasterMessage from '../containers/UI/ToasterMessage/toasterMessage';

// To get logged-in user token
const getLoggedInUserToken = () => {
    let userData = localStorage.getItem('loginCredentials');
    userData = JSON.parse(userData);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    if (userData) {
        headers.Authorization = `Bearer ${userData.accessToken}`;
        headers.loggedInUserData = {
            email: userData.email,
            password: userData.password,
        };
    }
    return headers;
};

const fetchMethodRequest = async (method, url, body, type, mul, extraBody) => {
    let headers = url === 'auth/login' ? {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    } : getLoggedInUserToken();

    if (type === 'upload') {
        const formData = new FormData();
        if (body && !mul) {
            formData.append('file', body);
        } else if (body && mul) {
            body.forEach(file => {
                formData.append('file', file);
            });
            if (extraBody) {
                Object.keys(extraBody).forEach(key =>
                    formData.append(key, extraBody[key])
                );
            }
        }
        body = formData;
        delete headers['Content-Type'];
        delete headers.loggedInUserData;
    }

    // ---------- PDF DOWNLOAD FIX ----------
    if (type === "pdfDownload") {
        delete headers["Content-Type"];
        headers["Accept"] = "*/*"; // allows binary response
    }
    return sendRequestToServer(method, url, body, headers, type)
        .then(response => {
            if (response?.errorCode === 9001) {
                return response;
            }
            return response;
        })
        .catch((err) => {
            console.error('Fetch error:', err);
            showToasterMessage(config.serverErrMessage, 'error');
            return 'serverError';
        });
};

const sendRequestToServer = async (method, url, body, headers, type) => {
    const reqHeaders = { ...headers };
    if (reqHeaders.loggedInUserData) {
        delete reqHeaders.loggedInUserData;
    }
    let isImageReqSent = false;
    let request;

    const options = { method, headers: reqHeaders };

    // Body handling
    if (body instanceof FormData) {
        delete options.headers['Content-Type'];
        options.body = body;
    } else if (body) {
        options.body = JSON.stringify(body);
    }

    try {
        // ---------- SWITCH URL BASED ON TYPE ----------
        const finalUrl =
            type === "pdfDownload"
                ? `${config.imgUrl}${url}`
                : `${config.apiUrl}${url}`;

        const response = await fetch(finalUrl, options);

        // ---------- PDF DOWNLOAD RETURNS BLOB ----------
        if (type === "pdfDownload") {
            if (!response.ok) throw new Error("PDF fetch failed");
            return response;
        }

        // ---------- NORMAL JSON ----------
        const responseJson = await response.json();
        if (responseJson?.errorMessage === "Session expired please login again.") {
            localStorage.setItem("sessionexpired", true);
        }
        return responseJson;
    } catch (err) {
        console.error(err);
        showToasterMessage(config.serverErrMessage, 'error');
        return "serverError";
    }
};

export default fetchMethodRequest;
